function getAssetConfig(): HTMLElement | null {
  return document.getElementById("remerlinds-asset-config");
}

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

export function initFancyboxLoader(): void {
  const config = getAssetConfig();
  if (!config || config.dataset.fancyboxEnabled !== "true") return;

  const fancyboxCss = config.dataset.fancyboxCssUrl;
  const fancyboxJs = config.dataset.fancyboxJsUrl;
  const fancyboxInit = config.dataset.fancyboxInitUrl;
  if (!fancyboxCss || !fancyboxJs || !fancyboxInit) return;
  const cssUrl = fancyboxCss;
  const jsUrl = fancyboxJs;
  const initUrl = fancyboxInit;

  let loaded = false;

  async function loadFancybox(clickEvent: MouseEvent): Promise<void> {
    if (loaded) return;
    loaded = true;

    try {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssUrl;
      document.head.appendChild(link);

      await loadScript(jsUrl);
      await loadScript(initUrl);

      const target = clickEvent.target as Element | null;
      target
        ?.closest("button")
        ?.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
    } catch (error) {
      loaded = false;
      console.warn("Fancybox failed to load", error);
    }
  }

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target as Element | null;
      const button = target?.closest("modal-opener button[data-media-id]");
      if (!button || "Fancybox" in window) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      void loadFancybox(event);
    },
    { capture: true }
  );
}
